import React from 'react';



export class TimerHidden extends React.Component {



  render() {
    return (
      <div>
        <h1>{this.props.timerOverMessage}</h1>
        <h3> {this.props.timerOverSubMessage} </h3>
        <div className="row">

        
        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/Components/App/TimerHidden.js